import React from 'react';
import { FiPlus, FiHome, FiLogOut } from 'react-icons/fi';
import { FaBoxes } from 'react-icons/fa';
import './NavbarDash.scss';
import Logo from "../../Assets/Images/logo.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedoutUser } from "../../Redux/slices/user";
import Swal from "sweetalert2";

const Navbar = () => {
    const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(getLoggedoutUser());
    Swal.fire({
      icon: "success",
      title: "Logged Out Successfully",
    });
  };

  return (
    <nav className="navbard">
      <div className="logod">
        <img src={Logo} alt="Logo"/>
      </div>
      <div className="navbard-icons">
      <Link to="/admin/createproject" >
        <div className="icon-wrapper">
          <FiPlus className="icon" />
          <span className="icon-label">Add Products</span>
        </div>
        </Link>
        <Link to="/admin/categories/create">
        <div className="icon-wrapper">
          <FaBoxes className="icon" />
          <span className="icon-label">Add Categories</span>
        </div>
        </Link>
        </div>
        <div className="navbardash-icons">
        <Link to={`/`}>
        <div className="icon-wrapper">
          <FiHome className="icon" />
          <span className="icon-label">Home</span>
        </div>
        </Link>
        <div className="icon-wrapper" onClick={handleLogout}>
          <FiLogOut className="icon" />
          <span className="icon-label">Logout</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
